/**
 * SearchTabs
 *
 * View that deals with interaction between the list and map views
 *
 * @return {view}
 */

OT.createNS('OT.Redesign.Views.SearchTabs');

OT.Redesign.Views.SearchTabs = Backbone.ViewManager.BaseView.extend({
    el: '.view-toggle',

    template: 'Redesign/Filters/_FilterViewOptions',

    events: {
        'click #view_toggle div': 'toggle'
    },

    selectedClass: 'selected',

    viewTypes: ['list', 'map'],

    initialize: function() {
        this.selectors = {
            body: 'body',
            viewToggle: '#view_toggle'
        };

        this.$body = $(this.selectors.body);

        var self = this;
        OT.Events.on('results:done', function() {
            self.render();
        });
    },

    onRender: function() {
        this.initSelectedView(this.getCurrentView());

        this.$el.find('.js-lionbars').lionbars({
            autohide: true
        });
    },

    beforeRender: function() {
        this.templateData = OT.Search.Data.get();

        return this;
    },

    reloadView: function(currentView) {
        OT.Search.Params.set({
            CurrentView: currentView,
            ShowMap: currentView === 'map'
        });

        this.viewChanged();
        $('.filters-bar').css('max-height', '');
    },

    viewChanged: function() {
        OT.Search.Requests.Results.get({
            supressSearchHistory: true
        });
    },

    getCurrentView: function() {
        return OT.Search.Data.get().Display.CurrentView;
    },

    initSelectedView: function(selectedView) {
        this.setSelectedViewBody(selectedView);
        this.setSelectedViewOption(selectedView);
    },

    setSelectedViewBody: function(selectedView) {
        var $body = this.$body;

        _.forEach(this.viewTypes, function(viewType) {
            $body.removeClass(viewType);
        });

        $body.addClass(selectedView);
    },

    setSelectedViewOption: function(selectedView) {
        var self = this;
        $(this.selectors.viewToggle)
            .find('div[data-view]')
            .each(function() {
                var $el = $(this);
                $el.toggleClass(self.selectedClass, $el.data('view') === selectedView);
            });
    },

    toggle: function(e) {
        e.preventDefault();

        var selectedView = $(e.currentTarget).data('view');

        this.setSelectedViewOption(selectedView);

        if (window.OTSearchData.Experiments.sv1493) {
          window.OTSearchBundle.changeView(selectedView);
        }

        OT.Search.Params.set({
            CurrentView: selectedView
        });

        this.reloadView(selectedView);
    }
});
